import moment from 'moment';
import React, { useState } from 'react';
import { FormattedMessage, useIntl, FormattedDate } from 'react-intl';

// material-ui imports
import { TextField, IconButton, makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';

import DeleteIcon from '../../common/icons/deleteIcon';
import { Caption } from '../workOrderDetails'
import DateTimePicker from '../../common/datepicker/dateTimePicker';

import { useEntryStyle } from './RelatedWork';


const useStyles = makeStyles((theme) => ({
    numberInput: {
        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            display: "none"
        }
    },
    characterCount: {
        float: 'right',
        marginTop: '-20px',
        marginRight: '15px',
        fontSize: '10px',
        color: '#999999'
    }
}));


const LocateRowEdit = (props) => {
    const { removeLocate } = props;
    const classes = Object.assign(useStyles(), useEntryStyle());

    const NUMLENGTH = 20, COMMENTLENGTH = 250;

    //const row = props.row;
    const [locate, setLocate] = useState(props.locate);
    const [, refreshState] = useState({});

    const update = (event, key, isDate) => {
        if (isDate)
            locate[key] = event;
        else
            locate[key] = event.target.value;
        locate.dirty = true;
        refreshState({});
    }
    return (
        <Grid className={classes.entryContainer + ' ' + classes.entrySpacing} item xs={12}>
            <Grid container spacing={1} alignItems="center">
                <Grid item spacing={1} xs={12} sm container>
                    <Grid item lg={3} md={6} xs={12}>
                        <Caption>
                            <FormattedMessage
                                id='admin.work-order-details.locate-list.locate-number-col-header'
                                defaultMessage='Locate number'
                                description='Admin work order locate number column header'
                            />
                        </Caption>
                        <TextField
                            required
                            fullWidth
                            variant='outlined'
                            type='text'
                            onInput={(e) => {
                                if (e.target.value.length > NUMLENGTH) e.target.value = e.target.value.slice(0, NUMLENGTH);
                            }}
                            InputProps={{
                                classes: { input: classes.numberInput },
                                inputProps: {
                                    style: { padding: '10.5px' },
                                },
                            }}
                            error={!locate.locateNumber}
                            value={locate.locateNumber}
                            onChange={(event) => {
                                update(event, "locateNumber")
                            }}
                        />
                        <div className={classes.characterCount}>
                            {locate.locateNumber ? `${locate.locateNumber.length}/${NUMLENGTH}` : `0/${NUMLENGTH}`}
                        </div>
                    </Grid>
                    <Grid item lg={3} md={6} xs={12} className={classes.gridItem}>
                        <Caption>
                            <FormattedMessage
                                id='admin.work-order-details.locate-list.requested-date-col-header'
                                defaultMessage='Requested'
                                description='Admin work order Locate list Requested Date column header'
                            /> *
                        </Caption>
                        <DateTimePicker
                            fullWidth
                            variant='outlined'
                            dateType="requestedDate"
                            value={locate.requestedDate ? new Date(locate.requestedDate) : ""}
                            onChange={(date) => {
                                update(date, "requestedDate", true)
                            }}
                            error={null}
                            inputSize='small'
                            iconSize='small'
                        />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12} className={classes.gridItem}>
                        <Caption>
                            <FormattedMessage
                                id='admin.work-order-details.locate-list.received-date-col-header'
                                defaultMessage='Received'
                                description='Admin work order locate list received date column header'
                            />
                        </Caption>
                        <DateTimePicker
                            fullWidth
                            dateType="receivedDate"
                            value={locate.receivedDate ? new Date(locate.receivedDate) : ""}
                            
                            variant='outlined'
                            onChange={(date) => {
                                update(date, "receivedDate", true)
                            }}
                            error={null}
                            inputSize='small'
                            iconSize='small'
                        />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12} className={classes.gridItem}>
                        <Caption>
                            <FormattedMessage
                                id='admin.work-order-details.locate-list.expires-date-col-header'
                                defaultMessage='Expires'
                                description='Admin work order locate list Expires date column header'
                            />
                        </Caption>
                        <DateTimePicker
                            fullWidth
                            dateType="expirationDate"
                            value={locate.expirationDate ? new Date(locate.expirationDate) : ""}
                            variant='outlined'
                            inputSize='small'
                            iconSize='small'
                            onChange={(date) => {
                                update(date, "expirationDate", true)
                            }}
                            error={null}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Caption>
                            <FormattedMessage
                                id='admin.work-order-details.locate-list.comment-col-header'
                                defaultMessage='Comment'
                                description='Admin work order locate list Comment column header'
                            />
                        </Caption>
                        <TextField
                            className={classes.root}
                            textareastyle
                            variant='outlined'
                            InputProps={{
                                inputProps: {
                                    maxLength: COMMENTLENGTH
                                }
                            }}
                            fullWidth
                            multiline
                            value={locate.comment}
                            onChange={(event) => {
                                update(event, "comment")
                            }}
                        />
                        <div className={classes.characterCount}>
                            {locate.comment ? `${locate.comment.length}/${COMMENTLENGTH}` : `0/${COMMENTLENGTH}`}
                        </div>
                    </Grid>
                </Grid>
                <Grid item>
                    <IconButton
                        style={{
                            padding: 'unset'
                        }}
                        size={'small'}
                        onClick={() => removeLocate()}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default LocateRowEdit;
